<!--销售记账组件-->
<template>
   <div>
       <!--面包屑导航-->
       <el-breadcrumb separator-class="el-icon-arrow-right">
           <el-breadcrumb-item>养殖日志</el-breadcrumb-item>
           <el-breadcrumb-item>销售记账</el-breadcrumb-item>
       </el-breadcrumb>
       <!--添加销售金额-->
       <el-button type="primary" icon="el-icon-plus" style="margin-bottom: 15px" @click="add">添加</el-button>
       <el-dialog title="添加销售金额(单)" :visible.sync="dialogFormVisible">
           <el-form :model="form" :rules="rules" ref="form">
               <el-form-item label="销售金额" prop="total" :label-width="formLabelWidth">
                   <el-input v-model="form.total" autocomplete="off" placeholder="输入销售金额(总)"></el-input>
               </el-form-item>
               <el-form-item label="销售种类" prop="name" :label-width="formLabelWidth">
                   <el-select v-model="form.name" placeholder="选择销售物品种类">
                       <el-option  v-for="item in salesAccountList" :key="item" :label="item"
                                   :value="item"></el-option>
                   </el-select>
               </el-form-item>
               <el-form-item label="数量" prop="count" :label-width="formLabelWidth" >
                   <el-input v-model="form.count" autocomplete="off" placeholder="输入数量" style="width: 200px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                   <el-select style="width: 120px;display: inline-block" v-model="form.unit" placeholder="选择单位">
                       <el-option  v-for="item in ['斤','升']" :key="item" :label="item"
                                   :value="item"></el-option>
                   </el-select>
               </el-form-item>
               <el-form-item label="活动时间" :label-width="formLabelWidth">
                   <el-col :span="10">
                       <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form.date" style="width: 100%;"></el-date-picker>
                   </el-col>
                   <el-col class="line" :span="1">----</el-col>
                   <el-col :span="10">
                       <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" v-model="form.time" style="width: 100%;"></el-time-picker>
                   </el-col>
               </el-form-item>
               <el-form-item label="其他信息" prop="description" :label-width="formLabelWidth">
                   <el-input type="textarea" v-model="form.remark" placeholder="请添加其他描述信息"></el-input>
               </el-form-item>
           </el-form>
           <div slot="footer" class="dialog-footer">
               <el-button @click="closeAdd">取 消</el-button>
               <el-button type="primary" @click="submitSalesAccountAdd('form')">确 定</el-button>
           </div>
       </el-dialog>
       <!--更新销售金额-->
       <el-dialog title="更新销售金额" :visible.sync="updateDialogFormVisible">
           <el-form :model="updateForm" :rules="rules" ref="form">
               <el-form-item label="更新销售金额(总)" prop="total" :label-width="formLabelWidth">
                   <el-input v-model="updateForm.total" autocomplete="off" placeholder="输入销售金额(单)"></el-input>
               </el-form-item>
               <el-form-item label="销售种类" prop="name" :label-width="formLabelWidth">
                   <el-select v-model="updateForm.name" placeholder="选择销售物品种类">
                       <el-option  v-for="item in salesAccountList" :key="item" :label="item"
                                   :value="item"></el-option>
                   </el-select>
               </el-form-item>
               <el-form-item label="数量" prop="count" :label-width="formLabelWidth" >
                   <el-input v-model="updateForm.count" autocomplete="off" placeholder="输入数量" style="width: 200px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                   <el-select style="width: 120px;display: inline-block" v-model="updateForm.unit" placeholder="选择单位">
                       <el-option  v-for="item in ['斤','升']" :key="item" :label="item"
                                   :value="item"></el-option>
                   </el-select>
               </el-form-item>
               <el-form-item label="活动时间" :label-width="formLabelWidth" prop="time">
                   <el-col :span="10">
                       <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="updateForm.date" style="width: 100%;"></el-date-picker>
                   </el-col>
                   <el-col class="line" :span="1">----</el-col>
                   <el-col :span="10">
                       <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" v-model="updateForm.time" style="width: 100%;"></el-time-picker>
                   </el-col>
               </el-form-item>
               <el-form-item label="其他信息" prop="description" :label-width="formLabelWidth">
                   <el-input type="textarea" v-model="updateForm.remark" placeholder="请添加其他描述信息"></el-input>
               </el-form-item>
           </el-form>
           <div slot="footer" class="dialog-footer">
               <el-button @click="closeUpdate">取 消</el-button>
               <el-button type="primary" @click="makeHandleUpdate">确 定</el-button>
           </div>
       </el-dialog>
       <!--表格区域-->
       <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
           <el-table-column prop="name" label="名称" align="center"></el-table-column>
           <el-table-column prop="total" label="销售金额" align="center"></el-table-column>
           <el-table-column prop="count" label="数量" align="center"></el-table-column>
           <el-table-column prop="sysTime" label="填写时间" align="center"></el-table-column>
           <el-table-column prop="remark" label="备注" align="center"></el-table-column>
           <el-table-column width="300" align="center" fixed="right" label="操作">
               <template slot-scope="scope">
                   <el-button @click="handleUpdate(scope.row)" type="primary" icon="el-icon-edit" size="medium">修改</el-button>
                   <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" size="medium">删除</el-button>
               </template>
           </el-table-column>
       </el-table>
       <!--分页器-->
       <el-pagination background
                      layout="prev, pager, next"
                      :total="total"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      style="text-align: center;margin-top: 10px"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentPage" >
       </el-pagination>
   </div>
</template>

<script>
    import request from "../../../http/dialog";
    import {positiveNumber} from "../../../utils/validate";
    export default {
        name: "salesAccount",
        inject: ['reload'],
        data(){
            return{
                //表格列表数据
                tableData: [],
                currentPage: 1, // 初始页
                pageSize: 8, //    每页的数据
                total:0, // 列表总数
                /*添加弹出表单*/
                form: {
                    total:'',// price: '',/*投入品金额*/
                    name: '', /*投入品类型*/
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                    remark: '', /*其他描述信息*/
                    count: '', /*苗种数量*/
                    unit:''/*单位*/
                },
                /*更新弹出表单*/
                updateForm:{
                    id: '',
                    total:'',//price: '',/*投入品金额*/
                    name: '', /*投入品类型*/
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                    remark: '', /*其他描述信息*/
                    count: '', /*苗种数量*/
                    unit:''/*单位*/
                },
                sysTime:'', // 更新时间
                /*获取固定收入-->添加固定成本-->投入品类型列表*/
                salesAccountList:[],
                formLabelWidth: '120px', //表单宽度
                dialogFormVisible: false, /*添加弹出表单默认属性为false*/
                updateDialogFormVisible: false, /*更新弹出表单默认属性为false*/
                loading: true, //table区域加载
                rules: {
                    total: [
                        { validator: positiveNumber, trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请选择投入品类型', trigger: 'change' }
                    ],
                    count: [
                        { required: true, message: '请选择数量', trigger: 'change' }
                    ],
                    time:[
                        { required: true, message: '请选择时间', trigger: 'change' }
                    ]

                }
            }
        },
        methods:{
            /*获取表格列表*/
            async getTableList(){
                let data = {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                let table = await request.salesTableList(data)
                this.tableData = table.data.data.list
                this.total = table.data.data.total
                this.loading = false
               // console.log(table);
            },
            // pageSize改变时触发
            handleSizeChange (size) {
                this.pagesize = size
                // console.log('handleSizeChange')
            },
            // 当前页面改变时触发
            handleCurrentPage (currentPage) {
              //   console.log(currentPage)
                this.currentPage = currentPage
                this.getTableList()
               // console.log('handleCurrentPage')
            },
            /*添加销售金额按钮方法*/
            async add(){
                this.dialogFormVisible = true;
                /*获取销售物品类型列表*/
                // let res = await request.salesAccountList()
                //console.log(res);
               //  this.salesAccountList = res.data.data
            },
            /*获取销售物品类型列表*/
            async getSalesAccountList(){
                let res = await request.salesAccountList()
                this.salesAccountList = res.data.data
            },
            // 更新操作
            handleUpdate(data){
                // console.log(data);
                this.updateDialogFormVisible = true;
                this.updateForm = data
                this.sysTime = data.sysTime
                /*let sysTime = data.sysTime.split(' ') // 按照空格分隔时间
                // console.log(sysTime);
                this.updateForm.date = sysTime[0]
                this.updateForm.time = sysTime[1]*/
            },
            // 确认更新
            async makeHandleUpdate(){
                this.updateDialogFormVisible = false
                // console.log(this.updateForm);
                let sendData = { /*添加固定收入传入数据*/
                    id: this.updateForm.id, /*id*/
                    type: 2, /*固定投入部分*/
                    total: this.updateForm.total,/*投入品金额*/
                    name: this.updateForm.name, /*投入品类型*/
                    /*date: '',/!*年月日*!/
                    time: '',/!*时分秒*!/*/
                    username: window.sessionStorage.getItem('name'), /*用户名*/
                    sysTime: this.sysTime ,/*用户自定义时间this.updateForm.date + ' '+this.updateForm.time*/
                    remark: this.updateForm.remark, /*其他描述信息*/
                    count: this.updateForm.count, /*苗种数量*/
                    unit: this.updateForm.unit
                }
                if (this.updateForm.name === '苗种')
                {
                    sendData.name = this.updateForm.seedling
                }
                if (this.updateForm.date && this.updateForm.time){
                    sendData.sysTime = this.updateForm.date + ' '+this.updateForm.time
                }
                //console.log(sendData);
                let res = await request.updateStableIncome(sendData)
                //console.log(res);
                if (res.data.msg === 'SUCCESS') {
                    this.$message.success('更新成功')
                    this.reload() // 局部刷新这里
                }else {
                    this.$message.info('更新失败')
                }
            },
            closeUpdate () { // 取消更新
                this.updateDialogFormVisible = false
                this.$message.info('取消更新')
            },
            // 删除操作
            handleDelete(data) {
                // console.log(data)
                this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let id = data.id
                    // 删除请求
                    request.deleteStableIncome(id).then(() => { // 异步操作执行完再执行里面的内容
                        // console.log(res);
                        this.reload()// 刷新页面显示最新状态
                        this.$message.success('删除成功!')
                    })

                }).catch(() => {
                    this.$message.info('已取消删除')
                })
            },
            //添加购买记账请求
             submitSalesAccountAdd(form){
                this.$refs[form].validate(async(valid) => {
                    if (valid) {
                        this.dialogFormVisible = false
                        let addData = { /*添加购买记账传入数据*/
                            name: this.form.name, /*销售记账类型*/
                           // price: this.form.price,/*价格*/
                            type: 2,/*销售记账*/
                            username: window.sessionStorage.getItem('name'),/*用户名*/
                            sysTime: this.form.date + ' '+this.form.time ,/*用户自定义时间*/
                            remark: this.form.remark, /*其他描述信息*/
                            count: this.form.count, /*数量*/
                            unit: this.form.unit,/*单位*/
                            total: this.form.total//this.form.price * this.form.count /*总价*/
                        }
                        //console.log(addData);
                        let tempAddData = await request.salesTableListAdd(addData)
                        //console.log(tempAddData);
                        if (tempAddData.data){
                            this.$message.success('添加成功')
                            location.reload()
                        }
                    } else {
                        //console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 取消添加
            closeAdd(){
                this.dialogFormVisible = false
                this.$message.info('取消添加')
            }
        },
        created() {
            this.getTableList()
        },
        mounted() {
            this.getSalesAccountList() /*获取销售物品类型列表*/
        }
    }
</script>

<style scoped>
    /*使用深度选择器修改分页器颜色样式*/
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1abc9c;
        color: #FFF;
    }
</style>
